import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import SEO from '../components/SEO';
const Wrap = styled.div`
  width: min(100%, 1800px);
  margin: clamp(12px, 3vw, 28px) auto;
  background: rgba(255, 255, 255, 0.95);
  border-radius: clamp(50px, 3vw, 22px);
  padding: clamp(25px, 2.6vw, 24px);
  box-shadow: 0 4px 6px rgba(241, 134, 13, 0.79);
  overflow: hidden;
`;

const Header = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);

  @media (max-width: 560px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const TitleBlock = styled.div`
  min-width: 0;
`;

const H1 = styled.h1`
  margin: 0;
  font-size: clamp(22px, 2.6vw, 30px);
  line-height: 1.15;
  color: #053969;
`;

const Sub = styled.p`
  margin: 8px 0 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: clamp(12.5px, 1.2vw, 14px);
  line-height: 1.45;
`;

const LangRow = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;

  @media (max-width: 560px) {
    justify-content: flex-start;
  }
`;

const LangBtn = styled.button`
  border: 1px solid rgba(5, 57, 105, 0.22);
  background: ${(p) => (p.$active ? '#053969' : 'transparent')};
  color: ${(p) => (p.$active ? '#fff' : '#053969')};
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 800;
  cursor: pointer;
  transition: 0.15s ease;
  font-size: 13px;

  &:hover {
    transform: translateY(-1px);
    opacity: 0.98;
  }

  &:active {
    transform: translateY(0px);
  }
`;

const Content = styled.div`
  padding-top: clamp(14px, 2.2vw, 20px);
`;

const Toc = styled.nav`
  background: rgba(5, 57, 105, 0.05);
  border: 1px solid rgba(5, 57, 105, 0.1);
  border-radius: 16px;
  padding: 12px 12px;
  margin-bottom: 16px;
`;

const TocTitle = styled.div`
  font-weight: 900;
  color: #053969;
  margin-bottom: 10px;
  font-size: 14px;
`;

const TocList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 10px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const TocLink = styled.a`
  display: block;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.78);
  padding: 8px 10px;
  border-radius: 12px;
  font-size: 13px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: rgba(255, 255, 255, 0.7);

  &:hover {
    color: #053969;
    border-color: rgba(5, 57, 105, 0.2);
  }
`;

const Section = styled.section`
  padding: 14px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.08);

  &:first-of-type {
    border-top: none;
    padding-top: 0;
  }
`;

const H2 = styled.h2`
  margin: 0 0 10px;
  color: #111;
  font-size: clamp(16px, 1.9vw, 20px);
  line-height: 1.2;
`;

const P = styled.p`
  margin: 0 0 10px;
  color: rgba(0, 0, 0, 0.78);
  font-size: clamp(13px, 1.25vw, 14.5px);
  line-height: 1.6;
`;

const Ul = styled.ul`
  margin: 0;
  padding-left: 18px;
  color: rgba(0, 0, 0, 0.78);
  font-size: clamp(13px, 1.25vw, 14.5px);
  line-height: 1.6;

  li {
    margin: 6px 0;
  }
`;

const Note = styled.div`
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.7);
  font-size: 13px;
  line-height: 1.55;
`;

const Email = styled.a`
  color: #053969;
  font-weight: 800;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export default function Privacy() {
  const [lang, setLang] = useState('en');
  const contactEmail = 'alexandru.moloman94@gmail.com'; // <- замени если надо
  const lastUpdated = '2026-01-01'; // <- можешь поставить реальную дату

  const copy = useMemo(() => {
    const base = {
      sections: [
        {
          id: 'general',
          title: '1. General Information',
          body: [
            `This website is a marketplace for websites operated by a single independent developer . All services, templates, and cooperation are provided directly by developer.`,
          ],
        },
        {
          id: 'data',
          title: '2. What Data I Collect',
          body: [
            `I may collect and process the following personal data provided by users through forms on this website:`,
          ],
          list: [
            'First name',
            'Last name',
            'Phone number',
            'Email address',
            'Budget for website development',
            'Any information provided voluntarily in the message/textarea fields',
            'Authentication and form submission data',
            'Cookie consent preferences',
          ],
        },
        {
          id: 'purpose',
          title: '3. Purpose of Data Collection',
          body: [`Personal data is collected for the following purposes:`],
          list: [
            'Responding to inquiries and requests',
            'Providing website development services',
            'Communicating with potential clients',
            'Preparing offers and project estimates',
            'Improving the quality of the website and services',
            'Ensuring proper website functionality (cookies)',
          ],
        },
        {
          id: 'templates',
          title: '4. Website Templates and Marketplace Access',
          body: [
            `This website functions as a marketplace where I publish website templates created by me.`,
            `Users may receive access to demo versions of templates, including administrative panel credentials, solely for testing and evaluation purposes.`,
            `These demo credentials are provided so users can fully explore the functionality before making a decision. Users are responsible for not misusing this access.`,
          ],
        },
        {
          id: 'cookies',
          title: '5. Cookies',
          body: [
            `This website uses cookies to store cookie consent preferences, ensure proper website functionality, and improve user experience.`,
            `You may accept or decline cookies at any time using the cookie banner.`,
          ],
        },
        {
          id: 'security',
          title: '6. Data Storage and Security',
          body: [
            `All reasonable measures are taken to protect personal data from unauthorized access, disclosure, or misuse.`,
            `Personal data is not sold or transferred to third parties.`,
          ],
        },
        {
          id: 'rights',
          title: '7. Your Rights',
          body: [
            `You have the right to request access to your personal data, request correction or deletion of your data, and withdraw consent at any time.`,
            `To exercise your rights, please contact me directly.`,
          ],
        },
        {
          id: 'contact',
          title: '8. Contact',
          body: [`For any privacy-related questions, please contact:`],
          contact: true,
        },
      ],
      tocTitle: 'On this page',
      subtitle: `Last updated: ${lastUpdated}`,
    };

    const ru = {
      sections: [
        {
          id: 'general',
          title: '1. Общая информация',
          body: [
            `Данный сайт является маркетплейсом веб-сайтов, управляемым одним независимым разработчиком. Все услуги, шаблоны и сотрудничество осуществляются напрямую с Разработчиком.`,
          ],
        },
        {
          id: 'data',
          title: '2. Какие данные я собираю',
          body: [
            `Я могу собирать и обрабатывать следующие персональные данные, предоставляемые пользователями через формы на сайте:`,
          ],
          list: [
            'Имя',
            'Фамилия',
            'Номер телефона',
            'Адрес электронной почты',
            'Бюджет на разработку сайта',
            'Любая информация, указанная пользователем в текстовых полях',
            'Данные авторизации и отправки форм',
            'Настройки согласия с использованием cookies',
          ],
        },
        {
          id: 'purpose',
          title: '3. Цели сбора данных',
          body: [`Персональные данные используются для:`],
          list: [
            'Ответа на запросы пользователей',
            'Предоставления услуг по разработке сайтов',
            'Связи с потенциальными клиентами',
            'Подготовки предложений и расчётов стоимости',
            'Улучшения качества сайта и услуг',
            'Обеспечения корректной работы сайта (cookies)',
          ],
        },
        {
          id: 'templates',
          title: '4. Шаблоны сайтов и доступ к маркетплейсу',
          body: [
            `Сайт функционирует как маркетплейс, на котором я размещаю шаблоны сайтов, созданные лично мной.`,
            `Пользователям может предоставляться доступ к демо-версиям шаблонов, включая данные для входа в административную панель, исключительно для тестирования и ознакомления.`,
            `Данные доступа предоставляются для того, чтобы пользователь мог максимально оценить функциональность шаблона перед принятием решения о покупке. Пользователь обязуется не использовать данный доступ в неправомерных целях.`,
          ],
        },
        {
          id: 'cookies',
          title: '5. Cookies',
          body: [
            `Сайт использует cookies для сохранения согласия пользователя, обеспечения корректной работы сайта и улучшения пользовательского опыта.`,
            `Вы можете принять или отклонить cookies в любое время с помощью баннера cookies.`,
          ],
        },
        {
          id: 'security',
          title: '6. Хранение и защита данных',
          body: [
            `Я принимаю разумные меры для защиты персональных данных от несанкционированного доступа, утечки или неправомерного использования.`,
            `Персональные данные не продаются и не передаются третьим лицам.`,
          ],
        },
        {
          id: 'rights',
          title: '7. Права пользователя',
          body: [
            `Вы имеете право запросить доступ к своим персональным данным, запросить их исправление или удаление, а также отозвать согласие на обработку данных в любое время.`,
            `Для реализации своих прав свяжитесь со мной напрямую.`,
          ],
        },
        {
          id: 'contact',
          title: '8. Контакты',
          body: [`По вопросам, связанным с конфиденциальностью, обращайтесь:`],
          contact: true,
        },
      ],
      tocTitle: 'Содержание',
      subtitle: `Последнее обновление: ${lastUpdated}`,
    };

    const it = {
      sections: [
        {
          id: 'general',
          title: '1. Informazioni generali',
          body: [
            `Questo sito web è un marketplace di siti web gestito da un unico sviluppatore indipendente Sviluppatore. Tutti i servizi, i template e la collaborazione avvengono direttamente con Sviluppatore.`,
          ],
        },
        {
          id: 'data',
          title: '2. Dati raccolti',
          body: [
            `Posso raccogliere e trattare i seguenti dati personali forniti dagli utenti tramite i moduli del sito:`,
          ],
          list: [
            'Nome',
            'Cognome',
            'Numero di telefono',
            'Indirizzo email',
            'Budget per lo sviluppo del sito web',
            'Qualsiasi informazione inserita volontariamente nei campi di testo',
            'Dati di autenticazione e invio dei moduli',
            'Preferenze relative ai cookie',
          ],
        },
        {
          id: 'purpose',
          title: '3. Finalità del trattamento',
          body: [`I dati personali vengono raccolti per le seguenti finalità:`],
          list: [
            'Rispondere alle richieste degli utenti',
            'Fornire servizi di sviluppo web',
            'Comunicare con potenziali clienti',
            'Preparare preventivi e offerte',
            'Migliorare la qualità del sito e dei servizi',
            'Garantire il corretto funzionamento del sito (cookie)',
          ],
        },
        {
          id: 'templates',
          title: '4. Template e accesso al marketplace',
          body: [
            `Il sito funziona come un marketplace dove pubblico template di siti web creati da me.`,
            `Gli utenti possono ricevere accesso a versioni demo dei template, incluse le credenziali di accesso all’area amministrativa, esclusivamente a scopo di test e valutazione.`,
            `Le credenziali demo sono fornite per consentire agli utenti di testare completamente il prodotto prima di prendere una decisione. L’utente si impegna a non utilizzare tali accessi in modo improprio.`,
          ],
        },
        {
          id: 'cookies',
          title: '5. Cookie',
          body: [
            `Questo sito utilizza cookie per salvare le preferenze di consenso ai cookie, garantire il corretto funzionamento del sito e migliorare l’esperienza utente.`,
            `È possibile accettare o rifiutare i cookie in qualsiasi momento tramite il banner dei cookie.`,
          ],
        },
        {
          id: 'security',
          title: '6. Conservazione e sicurezza dei dati',
          body: [
            `Vengono adottate misure adeguate per proteggere i dati personali da accessi non autorizzati, divulgazione o uso improprio.`,
            `I dati personali non vengono venduti né condivisi con terze parti.`,
          ],
        },
        {
          id: 'rights',
          title: '7. Diritti dell’utente',
          body: [
            `L’utente ha il diritto di richiedere l’accesso ai propri dati personali, richiedere la modifica o la cancellazione dei dati e revocare il consenso in qualsiasi momento.`,
            `Per esercitare tali diritti, contattami direttamente.`,
          ],
        },
        {
          id: 'contact',
          title: '8. Contatti',
          body: [`Per qualsiasi domanda relativa alla privacy:`],
          contact: true,
        },
      ],
      tocTitle: 'Indice',
      subtitle: `Ultimo aggiornamento: ${lastUpdated}`,
    };

    if (lang === 'ru') return ru;
    if (lang === 'it') return it;
    return base;
  }, [lang, lastUpdated]);

  const pageTitle =
    lang === 'ru'
      ? 'Политика конфиденциальности'
      : lang === 'it'
      ? 'Informativa sulla Privacy'
      : 'Privacy Policy';

  return (
    <Wrap>
      <SEO
        title="Privacy Policy"
        description="Privacy policy for website templates and services."
        path="/privacy"
      />
      <Header>
        <TitleBlock>
          <H1>{pageTitle}</H1>
          <Sub>{copy.subtitle}</Sub>
        </TitleBlock>

        <LangRow>
          <LangBtn type="button" onClick={() => setLang('en')} $active={lang === 'en'}>
            EN
          </LangBtn>
          <LangBtn type="button" onClick={() => setLang('ru')} $active={lang === 'ru'}>
            RU
          </LangBtn>
          <LangBtn type="button" onClick={() => setLang('it')} $active={lang === 'it'}>
            IT
          </LangBtn>
        </LangRow>
      </Header>

      <Content>
        <Toc aria-label="Table of contents">
          <TocTitle>{copy.tocTitle}</TocTitle>
          <TocList>
            {copy.sections.map((s) => (
              <TocLink key={s.id} href={`#${s.id}`}>
                {s.title}
              </TocLink>
            ))}
          </TocList>
        </Toc>

        {copy.sections.map((s) => (
          <Section key={s.id} id={s.id}>
            <H2>{s.title}</H2>

            {s.body?.map((text, idx) => (
              <P key={idx}>{text}</P>
            ))}

            {s.list?.length ? (
              <Ul>
                {s.list.map((li, idx) => (
                  <li key={idx}>{li}</li>
                ))}
              </Ul>
            ) : null}

            {s.contact ? (
              <P>
                <Email href={`mailto:${contactEmail}`}>{contactEmail}</Email>
              </P>
            ) : null}
          </Section>
        ))}

        <Note>
          {lang === 'ru'
            ? 'Примечание: демонстрационные доступы (логин/пароль) предоставляются только для ознакомления и тестирования шаблонов. Пожалуйста, не используйте их для неправомерных действий.'
            : lang === 'it'
            ? 'Nota: le credenziali demo (login/password) vengono fornite esclusivamente per test e valutazione dei template. Si prega di non utilizzarle in modo improprio.'
            : 'Note: demo credentials (login/password) are provided strictly for testing and evaluating templates. Please do not misuse them.'}
        </Note>
      </Content>
    </Wrap>
  );
}
